import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, Link, useNavigate } from 'react-router-dom';
import api from './services/api';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Dashboard from './pages/Dashboard';
import CreateQR from './pages/CreateQR';
import QRDetail from './pages/QRDetail';

function PrivateRoute({ children }) {
  return localStorage.getItem('token') ? children : <Navigate to="/login" />;
}

function Nav() {
  const navigate = useNavigate();
  const logout = () => { localStorage.clear(); navigate('/login'); };
  return (
    <nav style={{ background: '#6366f1', padding: '12px 24px', display: 'flex', alignItems: 'center', gap: 16 }}>
      <Link to="/" style={{ color: '#fff', fontWeight: 700, fontSize: 20, textDecoration: 'none' }}>🔲 QR App</Link>
      <div style={{ flex: 1 }} />
      <Link to="/" style={{ color: '#e0e0ff', textDecoration: 'none' }}>Dashboard</Link>
      <Link to="/create" style={{ color: '#e0e0ff', textDecoration: 'none' }}>Create QR</Link>
      <button onClick={logout} style={{ background: 'rgba(255,255,255,.2)', color: '#fff', border: 'none', padding: '6px 14px', borderRadius: 6, cursor: 'pointer' }}>Logout</button>
    </nav>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/*" element={
          <PrivateRoute>
            <Nav />
            <div style={{ maxWidth: 1100, margin: '0 auto', padding: 24 }}>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/create" element={<CreateQR />} />
                <Route path="/qr/:id" element={<QRDetail />} />
              </Routes>
            </div>
          </PrivateRoute>
        } />
      </Routes>
    </BrowserRouter>
  );
}
